import { render, staticRenderFns } from "./ToznyLoader.vue?vue&type=template&id=470191cf&"
import script from "./ToznyLoader.vue?vue&type=script&lang=js&"
export * from "./ToznyLoader.vue?vue&type=script&lang=js&"
import style0 from "./ToznyLoader.vue?vue&type=style&index=0&id=470191cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports